export default __webpack_public_path__ + "9d7d7dcdea7ea3d134f0d23f2a466880.png";